import React from 'react';
import { InputLabelWrapper, ShimmerLoader } from '@guildeducationinc/recess';

export interface LoadingPlaceholderFieldProps {
  helpText: string;
  inputId: string;
  label: string;
  loading: boolean;
  required: boolean;
}

const LoadingPlaceholderField: React.FC<LoadingPlaceholderFieldProps> = ({
  helpText,
  inputId,
  label,
  loading,
  required,
}) => (
  <>
    <InputLabelWrapper helpText={helpText} inputId={inputId} label={label} required={required} />
    <ShimmerLoader label={label} loaded={!loading} />
  </>
);

export default LoadingPlaceholderField;
